import * as ko from "knockout";
import {IOrganization} from "../index";
import {getEadmRole} from "../util/misc";
import {Permission} from "../constants";

export class PermissionValidator {
    constructor(private selectedOrganization: KnockoutObservable<IOrganization | null>) {
    }

    role = ko.pureComputed((): Permission => {
        return getEadmRole(this.selectedOrganization());
    });

    isMinEmployee = ko.pureComputed(() => this.role() >= Permission.Employee);
    isMinSuperEmployee = ko.pureComputed(() => this.role() >= Permission.SuperEmployee);
    isMinDepartmentAdmin = ko.pureComputed(() => this.role() >= Permission.DepartmentAdmin);
    isMinSuperManager = ko.pureComputed(() => this.role() >= Permission.SuperManager);
    isMinCompanyAdmin = ko.pureComputed(() => this.role() >= Permission.CompanyAdmin);
    isMinOrganizationAdmin = ko.pureComputed(() => this.role() >= Permission.OrganizationAdmin);

    isMaxEmployee = ko.pureComputed(() => this.role() <= Permission.Employee);
    isMaxSuperEmployee = ko.pureComputed(() => this.role() <= Permission.SuperEmployee);
    isMaxDepartmentAdmin = ko.pureComputed(() => this.role() <= Permission.DepartmentAdmin);
    isMaxSuperManager = ko.pureComputed(() => this.role() <= Permission.SuperManager);
    isMaxCompanyAdmin = ko.pureComputed(() => this.role() <= Permission.CompanyAdmin);
    isMaxOrganizationAdmin = ko.pureComputed(() => this.role() <= Permission.OrganizationAdmin);

    superAdmin = ko.pureComputed(() => this.role() == Permission.SuperAdmin);
}
